import { isEmpty as _isEmpty } from 'lodash';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import ProjectTile from './ProjectTile';
import { destroySectionUnit } from '../../actions/sectionUnitActions';
import { saveUnit } from '../../actions/unitActions';
import { selectAssignment } from '../../selectors/assignmentSelectors';
import { selectEnrollmentForBootcamp } from '../../selectors/enrollmentSelectors';
import { selectCohortForEnrollment } from '../../selectors/cohortSelectors';
import { selectProgressForAssignment } from '../../selectors/assignmentProgressSelectors';

const mapStateToProps = (state, ownProps) => {
  const { unit, bootcamp } = ownProps;

  const assignment = selectAssignment(state, unit && unit.assignment_id);
  const enrollment = selectEnrollmentForBootcamp(state, bootcamp.id);
  const cohort = enrollment && selectCohortForEnrollment(state, enrollment.id);
  const assignmentProgress = selectProgressForAssignment(state, unit && unit.assignment_id);

  return {
    assignment,
    enrollment,
    cohort,
    assignmentProgress,
  };
};

export default connect(mapStateToProps, { destroySectionUnit, saveUnit })(withRouter(ProjectTile));
